import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useDeleteContact = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);

  const onDeleteContactError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(
      'Something went wrong while deleting the contact.',
    );
  };

  const onDeleteContactSuccess = (callbackFn?: () => void) => ({
    data,
    message,
  }: SuccessHttpResponse<any>) => {

    if (callbackFn) {
      callbackFn();
    }
  };

  const deleteContact = (id: string, callbackFn?: () => void) => {
    const url: HttpConfig = {
      url: `api/v1/contacts/${id}`,
      method: 'delete',
      // data,
    };
    request(url, onDeleteContactSuccess(callbackFn), setLoading, onDeleteContactError);
  };

  return { deleteContact, loading };
};

export default useDeleteContact;
